import {
  LOAD_EXPRESS_DATA_REQUEST,
  LOAD_EXPRESS_DATA_SUCCESS,
  LOAD_EXPRESS_DATA_FAILURE,
  RESET_EXPRESS_STATE,
} from "./constants";

export const loadExpressDataRequest = (purchaseLink, packageType) => ({
  type: LOAD_EXPRESS_DATA_REQUEST,
  payload: { purchaseLink, packageType },
});

export const loadExpressDataSuccess = (data) => ({
  type: LOAD_EXPRESS_DATA_SUCCESS,
  payload: data,
});

export const loadExpressDataFailure = (error) => ({
  type: LOAD_EXPRESS_DATA_FAILURE,
  payload: error,
});

export const resetExpressState = () => ({
  type: RESET_EXPRESS_STATE,
});
